/**
 * The countries this business quotes between.
 *
 * WHY THIS IS A SECOND COPY. The authoritative list is
 * `backend/src/Domain/Shared/Support/TradingCountries.php`, which the pricing-rule conditions form
 * and the admin RFQ form both read. It cannot be shared with this file automatically: the
 * TypeScript transformer emits PHP enums as union types and has no way to carry a label map across,
 * so the codes could be generated but the names could not.
 *
 * KEEP THEM IN STEP, and the reason is not tidiness. A rate can be scoped to a country pair, and
 * `CalculatePrice` reads a stated condition against a null actual as NO MATCH. A country a rule can
 * be scoped to but this form cannot record is a rule that silently matches nothing — which is the
 * bug these fields were added to fix. Dropping an entry here reintroduces it for that corridor.
 *
 * A generated single source is the right answer and was not a same-day change.
 */
export const TRADING_COUNTRIES: { code: string; name: string }[] = [
  { code: 'KE', name: 'Kenya' },
  { code: 'UG', name: 'Uganda' },
  { code: 'TZ', name: 'Tanzania' },
  { code: 'RW', name: 'Rwanda' },
  { code: 'BI', name: 'Burundi' },
  { code: 'SS', name: 'South Sudan' },
  { code: 'CD', name: 'DR Congo' },
  { code: 'ET', name: 'Ethiopia' },
  { code: 'SO', name: 'Somalia' },
  { code: 'DJ', name: 'Djibouti' },
  { code: 'ZM', name: 'Zambia' },
  { code: 'MW', name: 'Malawi' },
  { code: 'MZ', name: 'Mozambique' },
  { code: 'ZW', name: 'Zimbabwe' },
  { code: 'ZA', name: 'South Africa' },
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'CN', name: 'China' },
  { code: 'IN', name: 'India' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'NL', name: 'Netherlands' },
];
